(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.pdf.view
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.page.lp-portal.report.pdf.view :refer [report]]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.tearsheet :as re-tearsheet]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.big-figure.pdf.view :as big-figures]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.esg :as re-esg]))

(defn- recent-development-page
  [report-data]
  (let [{:keys [recent-development recent-development-text overview-figures]} (-> report-data
                                                                                  :overview)]
    (page/page
     (page/third-column-background)
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview" :toc-item true})
     (column/columns-2-to-1
      (card/card
       "Recent development"
       (text-content/rich-content (:rich-content recent-development-text)))
      (card/card
       nil
       (big-figures/table (:figures overview-figures) 1 {:row-gap 12})
       (text-content/optional-footer overview-figures))))))

(defn- charts-page
  [report-data]
  (page/page
   (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
   {:stack
    [(column/columns
      (card/card
       "Lettable area by sector, sqm"
       {:svg   (chart-view/chart-svg "highcharts"
                                     (potpuri/deep-merge
                                      (-> report-data
                                          :overview
                                          :lettable-area-by-sector
                                          :figures)
                                      {:chart {:width  500
                                               :height 400}}))
        :width 400}
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :lettable-area-by-sector)))
      (card/card
       "Leased area by tenant, sqm"
       {:svg   (chart-view/chart-svg "highcharts"
                                     (potpuri/deep-merge
                                      (-> report-data
                                          :overview
                                          :leased-area-by-tenant
                                          :figures)
                                      {:chart {:width  500
                                               :height 400}}))
        :width 400}
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :leased-area-by-tenant))))]}))

(defn overview-pages
  [report-data]
  (concat
   [(recent-development-page report-data)]
   (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Debt financing"}
                              "Fund figures"
                              (-> report-data
                                  :overview
                                  :highlights)
                              {:odd-color     (theme/color [:pdf :table :odd-color])
                               :even-color    (theme/color [:pdf :table :even-color])
                               :heading-color (theme/color [:pdf :table
                                                            :heading-color])})
   [(charts-page report-data)]))

(defn debt-financing-pages
  [report-data]
  [(page/page
    (page/page-title
     {:fund-name (:fund-name report-data) :page-title "Debt financing" :toc-item true})
    (column/columns
     (card/card "Description"
                (text-content/rich-content (:rich-content (-> report-data
                                                              :debt-financing
                                                              :debt-financing-text))))
     (table/dynamic-table-card "Portfolio debt key figures"
                               (-> report-data
                                   :debt-financing
                                   :debt-key-figures)
                               {:full-width?   true
                                :odd-color     (theme/color [:pdf :table :odd-color])
                                :even-color    (theme/color [:pdf :table :even-color])
                                :heading-color (theme/color [:pdf :table
                                                             :heading-color])})))
  ])

(defn details-and-figures-pages
  [report-data]
  (let [{:keys [current-portfolio exited-portfolio limited-partners senior-loan-facility
                nav-breakdown]}
        (:details-and-figures report-data)]
    (concat
     (table/dynamic-table-pages
      {:fund-name (:fund-name report-data) :page-title "Details and figures" :toc-item true}
      "Current portfolio, €"
      current-portfolio
      {:full-width?   true
       :odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])})
     (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                 :page-title "Details and figures"}
                                "Investors, €"
                                limited-partners
                                {:full-width?   true
                                 :odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                 :page-title "Details and figures"}
                                "Investment summary, €"
                                (-> report-data
                                    :details-and-figures
                                    :investment-summary)
                                {:full-width?    true
                                 :hidden-columns #{"IQID"}
                                 :odd-color      (theme/color [:pdf :table :odd-color])
                                 :even-color     (theme/color [:pdf :table :even-color])
                                 :heading-color  (theme/color [:pdf :table
                                                               :heading-color])})

     #_(table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                   :page-title "Details and figures"}
                                  "Senior loan facility"
                                  senior-loan-facility
                                  {:full-width?   true
                                   :odd-color     (theme/color [:pdf :table :odd-color])
                                   :even-color    (theme/color [:pdf :table :even-color])
                                   :heading-color (theme/color [:pdf :table
                                                                :heading-color])})
     (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                 :page-title "Details and figures"}
                                "NAV Breakdown, €"
                                nav-breakdown
                                {:full-width?   true
                                 :odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])}))))

(defn financial-statements-pages
  [report-data]
  (let [{:keys [consolidated-income-statement statement-of-financial-position]}
        (:financial-statements report-data)]
    (concat
     (table/dynamic-table-pages
      {:fund-name (:fund-name report-data) :page-title "Financial statements" :toc-item true}
      "Consolidated income statement (FAS), €"
      consolidated-income-statement)
     (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                 :page-title "Financial statements"}
                                "Consolidated Balance Sheet (FAS), €"
                                statement-of-financial-position
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])}))))

(defn financial-performance-pages
  [report-data]
  [(page/page
    (page/page-title
     {:fund-name (:fund-name report-data) :page-title "Financial performance" :toc-item true})
    (column/column
     (card/card "Financial performance"
                (text-content/rich-content (:rich-content (-> report-data
                                                              :financial-performance
                                                              :financial-performance-text))))
     (card/card
      "NOI 1"
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge
                (-> report-data
                    :financial-performance
                    :noi
                    :figures)
                {:chart {:width  600
                         :height 250}}))
       :width 600}
      (text-content/optional-footer (-> report-data
                                        :financial-performance
                                        :noi)))))])

(defn risk-assessment-pages
  [report-data]
  [(page/page
    (page/page-title
     {:fund-name (:fund-name report-data) :page-title "Risk Assessment" :toc-item true})
    (column/column
     (card/card ""
                (text-content/rich-content (:rich-content (-> report-data
                                                              :risk-assessment-text))))))])

(defn koke-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(re-tearsheet/tearsheet-page report-data)]
   (overview-pages report-data)
   (financial-performance-pages report-data)
   (debt-financing-pages report-data)
   (re-esg/esg-pages report-data)
   (details-and-figures-pages report-data)
   (financial-statements-pages report-data)
   (risk-assessment-pages report-data)))

(defn koke
  [{:keys [reference-date reporting-period fund-name] :as view-data}]
  (report view-data (koke-pages view-data) fund-name reporting-period reference-date))
